module.exports = __webpack_public_path__ + "static/media/energetic_happy.66620bb0.svg";